import { render, staticRenderFns } from "./KazGateWay.vue?vue&type=template&id=00ea30be&scoped=true"
import script from "./KazGateWay.vue?vue&type=script&lang=js"
export * from "./KazGateWay.vue?vue&type=script&lang=js"
import style0 from "./KazGateWay.vue?vue&type=style&index=0&id=00ea30be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ea30be",
  null
  
)

export default component.exports